const routes = [
    // 外教授课进度路由
    {
      path: "/foreignProgress",
      name: "foreignProgress",
      meta: {
        title: "授课进度",
        volcengine: true
      },
      component: () => import("@/pages/lsForeign/foreignProgress/index.vue")
    },
    {
      path: "/foreignProgress/foreignDetail",
      name: "foreignProgress/foreignDetail",
      meta: {
        title: "授课进度详情",
        volcengine: true
      },
      component: () => import("@/pages/lsForeign/foreignProgress/progressDetail.vue")
    },
  ];
  export default routes;
  